import * as React from 'react'
import Dialog from 'material-ui/Dialog'
import { PrismaRequestDetailsAction } from './PrismaRequestDetailsActions'
import Button from 'material-ui-next/Button/Button'
import { ParcelDispatcher } from '../../Entities/ParcelDispatcher'
import { WithClasses } from '../../View/Helper'

export function PrismaRequestMarkAsDispatchedModal(
    {classes, dispatch, selectedParcelDispatcher, trackingNumber}:
        WithClasses<{
            selectedParcelDispatcher: ParcelDispatcher
            trackingNumber: string | null
            dispatch: (action: PrismaRequestDetailsAction) => void,
        }>,
) {

    const trackingUrl = trackingNumber ? selectedParcelDispatcher.trackingUrl + trackingNumber : null

    return (
        <div>
            <Dialog
                title="Daten überprüfen"
                modal={true}
                open={true}
            >
                <div style={{width: '100%', boxSizing: 'border-box', padding: '8px'}}>
                    <table>
                        <tbody>
                        <tr>
                            <th className={classes.tableHeader}>
                                Versanddienstleister
                            </th>
                            <td
                                className={classes.tableData}
                                style={{color: '#000'}}
                            >
                                {selectedParcelDispatcher.name}
                            </td>
                        </tr>
                        {trackingNumber && trackingUrl &&
                        <React.Fragment>
                            <tr>
                                <th className={classes.tableHeader}>
                                    Trackingnummer
                                </th>
                                <td
                                    className={classes.tableData}
                                    style={{color: '#000'}}
                                >
                                    {trackingNumber}
                                </td>
                            </tr>
                            <tr>
                                <th className={classes.tableHeader}>
                                    Link
                                </th>
                                <td
                                    className={classes.tableData}
                                    style={{color: '#000'}}
                                >
                                    <a
                                        className={classes.wrapLink}
                                        href={trackingUrl}
                                        target="_blank"
                                    >
                                        {trackingUrl}
                                    </a>
                                </td>
                            </tr>
                        </React.Fragment>
                        }
                        </tbody>
                    </table>
                </div>
                <div
                    style={{
                        display: 'flex',
                        flexDirectionflexDirection: 'row',
                        justifyContent: 'space-between',
                        marginTop: '1em',
                    }}
                >
                    <Button
                        color="secondary"
                        raised={true}
                        onClick={
                            () => {
                                dispatch(
                                    {
                                        'type': 'ToggleMarkAsDispatchedModal',
                                        'open': false,
                                    },
                                )
                            }
                        }
                    >
                        Abbrechen
                    </Button>
                    <Button
                        color="primary"
                        style={{
                            color: '#fff',
                        }}
                        raised={true}
                        onClick={
                            () => {
                                dispatch(
                                    {
                                        'type': 'MarkAsDispatched',
                                    },
                                )
                            }
                        }
                    >
                        Als versendet markieren
                    </Button>
                </div>
            </Dialog>
        </div>
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Pages/PrismaRequestDetails/PrismaRequestMarkAsDispatchedModal.tsx